import { combineReducers } from "redux";
import GetUserInfoReducer from "./GetUserInfo.reducer";

export default combineReducers({GetUserInfoReducer})